export default defineNuxtRouteMiddleware((to, from) => {
    // Lấy quyền từ localStorage hoặc state quản lý menu

    const { data } = useAuth();
    const { setPermission, setPermissionData } = usePermissions()
    const menuPermissions = data.value.menuPermissions;
    const dataPermissions = data.value.dataPermissions;
    if (!menuPermissions[to.name]) {
        throw showError({ statusCode: 403, message: "Không có quyền" })
    }
    setPermission(menuPermissions[to.name].quyen, menuPermissions)
    setPermissionData(dataPermissions)
    
});
